import { Injectable } from '@angular/core';

import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class FinishedFabricProperty1ReferenceService extends BaseReferenceService {
  constructor() {
    super('FinishedFabricProperty1Reference');
  }
}
